<template>
    <rkm-overlay>
        <rkm-layout-body title="Recepção">
            <template v-slot:actions>
                <rkm-button
                    color="primary"
                    @click="redirectToMainRecepcao"
                >
                    Paciente desconhecido
                </rkm-button>

                <rkm-button
                    v-if="isPermissaoCadastro"
                    color="primary"
                    @click.stop="showQuestion"
                >
                    Novo paciente
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List identificacao-paciente>
                    <template #actions="{ item }">
                        <rkm-button
                            :disabled=!!item.obitoEm
                            color="primary"
                            class="align-self-end"
                            @click="redirectToMainRecepcao(item)"
                        >
                            Recepcionar
                        </rkm-button>
                    </template>
                </List>
            </rkm-layout-content>
        </rkm-layout-body>

        <ModalPacienteCadastroSimplificado
            ref="ModalPacienteCadastroSimplificado"
            @save="redirectToMainRecepcao"
        />
    </rkm-overlay>
</template>

<script>
import List from '@/components/cadastro/paciente/components/busca/List'
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'

export default {
    components: { List, ModalPacienteCadastroSimplificado },
    props: {
        filaId: { type: Number },
        plantaoId: { type: Number },
        isPermissaoCadastro: { type: Boolean, default: false },
        dataAtendimento: { type: Date },
    },
    methods: {
        showQuestion() {

            this.showConfirmation('O paciente apresentou os documentos?',
                async () => this.$refs.ModalPacienteCadastroSimplificado.open(),
                async () => this.$refs.ModalPacienteCadastroSimplificado.openWithoutDocuments(this.dataAtendimento)
            )
        },
        redirectToMainRecepcao(paciente) {

            const params = {
                filaId: this.filaId,
                plantaoId: this.plantaoId,
                dataAtendimento: this.dataAtendimento
            }

            if (paciente) {

                params.pacienteId = paciente.id
            }

            this.$router.push({ name: 'pronto-atendimento-atendimento-recepcao-create', params })
        },
        redirectToList() {

            this.$router.push({ name: 'pronto-atendimento-atendimento-recepcao-index' })
        },
    },
    created() {

        if (!this.dataAtendimento) {

            this.redirectToList()
        }
    },
}
</script>